import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setBadgeCount, setPageTitle } from 'store/reducers/appLayoutReducer';

export function useHeaderChanger(title, count = 0) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle(title));
    setCount(count);
  }, []);

  const setCount = (count) => dispatch(setBadgeCount(count));

  return { setCount };
}
